var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-4"},[_c('h1',{staticClass:"mb-5 text--xl font-weight-medium"},[_vm._v(_vm._s(_vm.$t('navigation.group_template_assignment')))]),_c('GroupTemplatesAssignmentForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }